var map = {
	"./en-US.json": [
		78208,
		208
	],
	"./en.json": [
		13341,
		341
	],
	"./es.json": [
		87510,
		510
	],
	"./fr.json": [
		49998,
		998
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 63071;
module.exports = webpackAsyncContext;